<app-eca-modal-host [heading]="modalHeading"
                    (saveClicked)="saveClicked()"
                    (cancelClicked)="cancelClicked()" [isReadOnly]="isReadOnly"
                    (editClicked)="editClicked()"
                    (helpClicked)="helpClicked()"
                    [isEditing]="!isReadOnly"
                    [yesButtonIcon]="['far', 'save']"
                    [noButtonIcon]="['far', 'times']"
                    [editButtonIcon]="['far', 'edit']"
                    noButtonColour="transparent">
  <div class="container">
    <div class="row" *ngIf="showingHelp">
      <div class="col">
        <div class="alert alert-info">
          <div class="container-fluid">
            <div class="row">
              <div class="col-auto">
                <fa-icon [icon]="['far', 'question-circle']" size="4x" (click)="helpClicked()"></fa-icon>
              </div>
              <div class="col">
                <p>The bug logger screen allows you to record any issues you may have with the system.</p>
              </div>
              <div class="col-auto">
                <fa-icon [icon]="['far', 'times']" class="close" (click)="helpClicked()"></fa-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="container-fluid" *ngIf="!isReadOnly">
          <div class="row">
            <div class="col-md-12">
              <app-eca-input [(value)]="logItem.summaryInfo" [controlId]="'ctrlSummaryInfo'"
                             [isReadOnly]="isReadOnly"
                             [popoverText]="'Please enter summary information for this issue.'"
                             [validationMessage]="'Please enter summary information for this issue.'"
                             [isRequired]="true"
                             [label]="'Summary'">
              </app-eca-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="ctrlSectionSelect"><strong>eCOMS function that is raising a problem.</strong></label>
                <div class="input-group">
                  <select class="browser-default custom-select" id="ctrlSectionSelect" [disabled]="isReadOnly"
                          [(ngModel)]="logItem.section">
                    <option *ngFor="let option of sectionOptions"
                            [value]="option.value">
                      {{ option.label }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="ctrlCanReproduce"><strong>Is this a re-occurring issue?</strong></label>
                <div class="input-group">
                  <select class="browser-default custom-select" id="ctrlCanReproduce" [disabled]="isReadOnly"
                          [(ngModel)]="logItem.canReproduce">
                    <option [value]="true">
                      Yes
                    </option>
                    <option [value]="false">
                      No
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <app-eca-html-editor [(content)]="logItem.descriptionHtml"
                                   [isReadOnly]="isReadOnly"
                                   [popoverText]="'Please outline clearly in what way eCOMS is not working properly.'"
                                   [isRequired]="true"
                                   [label]="'Description'"
                                   [placeHolder]="'Enter issue details'"
                                   (contentChange)="logItem.descriptionHtml">
              </app-eca-html-editor>
            </div>
          </div>
          <div class="row d-flex justify-content-center ">
            <div class="col-12">
              <div class="container-fluid" style="max-width: 1140px;">
                <div class="row">
                  <div class="col m-0 p-0" *ngIf="!isReadOnly">
                    <div class="form-group">
                      <div class="flex-fill">
                        <label for="ctrlFileUpload"><strong>{{ctrlFileUploadLabel}}</strong></label>
                        <app-eca-input-guide class="float-right" style="margin-top: 40px;"
                                             popoverText="Please include relevant screen shots if you can"
                                             [isRequired]="false"
                                             [isDisabled]="false">
                        </app-eca-input-guide>
                      </div>
                      <p-fileUpload id="ctrlFileUpload" name="fileUpload" [auto]="true"
                                    [chooseLabel]="chooseLabel"
                                    (onRemove)="onRemove($event)"
                                    styleClass="" multiple="multiple"
                                    [accept]="acceptedFileTypes"
                                    [maxFileSize]="maxFileSize" customUpload="true" (uploadHandler)="onUpload($event)">
                        <ng-template pTemplate="content">
                          <p class="content-message">Drop  Your Files Here</p>
                        </ng-template>
                        <ng-template let-file pTemplate='file'>
                          <div>{{file.name | ellipsis : 10: false}}</div>
                          <div>{{file.size}}</div>
                          <div><button icon="fa-close" pButton type="button" label="Remove" (click)="onRemove(file)"></button></div>
                        </ng-template>
                      </p-fileUpload>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid" *ngIf="isReadOnly">
          <div class="row">
            <div class="col-md-12">
              <app-eca-input [(value)]="logItem.summaryInfo" controlId="ctrlSummary"
                             [isReadOnly]="isReadOnly"
                             [popoverText]="'Summary'"
                             [label]="'Summary'">
              </app-eca-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6" *ngIf="logItem.companyName">
              <app-eca-input [(value)]="logItem.companyName" controlId="ctrlCompanyName"
                             [isReadOnly]="isReadOnly"
                             [popoverText]="'Company'"
                             [label]="'Company'">
              </app-eca-input>
            </div>
            <div class="col-md-6" *ngIf="logItem.memberNumber != 0 ">
              <app-eca-input [(value)]="logItem.memberNumber" controlId="ctrlMemberNumber"
                             [isReadOnly]="isReadOnly"
                             [popoverText]="'Member Number'"
                             [label]="'Member Number'">
              </app-eca-input>
            </div>
            <div class="col-md-6">
              <app-eca-input [(value)]="logItem.loggedByEmail" controlId="ctrlLoggedByEmail"
                             [isReadOnly]="isReadOnly"
                             [popoverText]="'Logged By'"
                             [label]="'Logged By'">
              </app-eca-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <app-eca-html-editor [(content)]="logItem.descriptionHtml"
                                   [isReadOnly]="true"
                                   [popoverText]="'Issue Description'"
                                   [label]="'Description'"
                                   [placeHolder]="'Enter issue description'">
              </app-eca-html-editor>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <app-eca-input [value]="logItem?.section" controlId="ctrlSection"
                             [isReadOnly]="isReadOnly"
                             [popoverText]="'eCOMS function that is raising a problem.'"
                             [label]="'eCOMS function that is raising a problem.'">
              </app-eca-input>
            </div>
            <div class="col-md-6">
              <app-eca-input [controlId]="'ctrlCanReproduce'"
                             label="Is this a re-occurring issue?" [isReadOnly]="true"
                             [value]="logItem.canReproduce" [popoverText]="'Is this a re-occurring issue?'"
                             [isRequired]="false">
              </app-eca-input>
            </div>
            <div class="col-md-6">
              <app-eca-input [controlId]="'ctrlBrowserDetail'"
                             label="Browser Details" [isReadOnly]="true"
                             [value]="logItem.browserDetail" [popoverText]="'Browser Details'"
                             [isRequired]="false">
              </app-eca-input>
            </div>
            <div class="col-md-6">
              <app-eca-input [controlId]="'ctrlAppRoute'"
                             label="Route Details" [isReadOnly]="true"
                             [value]="logItem.appRoute" [popoverText]="'URL'"
                             [isRequired]="false">
              </app-eca-input>
            </div>
            <div class="col-md-6">
              <app-eca-input [(value)]="logItem.foundInVersion" controlId="ctrlFoundInVersion"
                             [isReadOnly]="true"
                             [popoverText]="'Found In App Version'"
                             [label]="'Found In Version'">
              </app-eca-input>
            </div>
            <div class="col-md-6" *ngIf="logItem.fixedInVersion">
              <app-eca-input [(value)]="logItem.fixedInVersion" controlId="ctrlFixedInVersion"
                             [isReadOnly]="isReadOnly"
                             [popoverText]="'Fixed In App Version'"
                             [label]="'Fixed In Version'">
              </app-eca-input>
            </div>
            <div class="col-md-6">
              <app-eca-date-picker [controlId]="'ctrlLoggedOn'"
                                   label="Logged On" [isDisabled]="true"
                                   [(dateValue)]="logItem.loggedOn" [popoverText]="'Logged On'"
                                   [isRequired]="false">
              </app-eca-date-picker>
            </div>
            <div class="col-md-6">
              <app-eca-input [value]="logItemStatus[logItem.itemStatus]" controlId="ctrlItemStatus"
                             [isReadOnly]="isReadOnly"
                             [popoverText]="'Status'"
                             [label]="'Status'"></app-eca-input>
            </div>
            <div class="col-md-6" *ngIf="logItem?.completionOn">
              <app-eca-date-picker [controlId]="'ctrlCompletionOn'"
                                   label="Completed On" [isDisabled]="isReadOnly"
                                   [(dateValue)]="logItem.completionOn"
                                   [isRequired]="false">
              </app-eca-date-picker>
            </div>
          </div>
          <div class="row" *ngIf="logItem?.documents?.length > 0">
            <div class="col-12">
              <p-table [totalRecords]="logItem?.documents?.length" [value]="logItem.documents">
                <ng-template pTemplate="header">
                  <tr>
                    <th>Supporting Documents</th>
                    <th></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-document>
                  <tr>
                    <td>{{document.originalFilename}}</td>
                    <td>
                      <div class="float-right">
                        <app-eca-row-menu [viewBtnVisible]="false"
                                          [rowMenuItems]="rowMenuItems"
                                          [contextItem]="document">
                        </app-eca-row-menu>
                      </div>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-eca-modal-host>
